









































































import { Component, Mixins } from 'vue-property-decorator'
import { ElTabPane } from 'element-ui/types/tab-pane'

import KintaiGetsudoFetch from '../mixins/KintaiGetsudoFetch'
import KintaiCardList from '@/components/kintai/organisms/KintaiCardList.vue'
import KintaiListTable from './KintaiListTable.vue'
import SummaryDrawer from './SummaryDrawer.vue'
import KeisanDrawer from './KeisanDrawer.vue'
import TeishutsuBrowse from '@/components/shounin/organisms/TeishutsuBrowse.vue'
import ShouninRireki from '@/components/shounin/organisms/ShouninRireki.vue'

@Component({
  components: {
    KintaiCardList,
    KintaiListTable,
    SummaryDrawer,
    KeisanDrawer,
    TeishutsuBrowse,
    ShouninRireki
  }
})
export default class KintaiGetsudoDataView extends Mixins(KintaiGetsudoFetch) {
  private activeTabName = 'kintai'
  private fitKintaiColumns(): void {
    const elem = (this.$refs.kintai as unknown) as { fit: () => void }
    if (elem && elem.fit instanceof Function) {
      elem.fit()
    }
  }
  protected clickTab(tab: ElTabPane): void {
    this.activeTabName = tab.name
    if (tab.name === 'kintai') {
      this.fitKintaiColumns()
    }
  }

  private mounted() {
    window.addEventListener('resize', this.handleResize)
  }

  private beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }

  private handleResize() {
    if (this.activeTabName === 'kintai') {
      this.fitKintaiColumns()
    }
  }

  private get tabPosition(): string {
    return this.isMobile ? '' : 'left'
  }

  private get tabPaneStyle() {
    if (this.isMobile) {
      return { height: `${this.height - 40}px`, 'overflow-y': 'auto' } // タブ分を引く
    } else {
      return { height: `${this.height}px`, 'overflow-y': 'auto' }
    }
  }
  get isTeishutsuLock(): boolean {
    if (this.teishutsu === null) {
      return false
    }
    if (Array.isArray(this.teishutsu)) {
      throw false
    }
    if (typeof this.teishutsu?.isLock !== 'boolean') {
      return false
    }
    return this.teishutsu?.isLock
  }
}
